import { EMAIL, PHONE_DISPLAY, PHONE_TEL, WA_LINK } from "../i18n";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-[130px] lg:px-10">
        <h1 className="font-serif text-5xl text-[#141414]">Impressum</h1>

        <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-gray-700">
          <section data-testid="impressum-info-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="mt-3">
              Singh Taxi
              <br />
              INA-Ring 12
              <br />
              91074 Herzogenaurach
              <br />
              Deutschland
            </p>
          </section>

          <section data-testid="impressum-contact-block">
            <h2 className="font-serif text-2xl text-[#141414]">Kontakt</h2>
            <p className="mt-3">
              Telefon:{" "}
              <a href={PHONE_TEL} className="font-semibold text-gold-dark hover:underline">
                {PHONE_DISPLAY}
              </a>
              <br />
              E-Mail:{" "}
              <a href={`mailto:${EMAIL}`} className="font-semibold text-gold-dark hover:underline">
                {EMAIL}
              </a>
              <br />
              WhatsApp:{" "}
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-gold-dark hover:underline"
              >
                {PHONE_DISPLAY}
              </a>
            </p>
          </section>

          <section data-testid="impressum-responsible-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="mt-3">
              Singh Taxi
              <br />
              INA-Ring 12, 91074 Herzogenaurach, Deutschland
            </p>
          </section>

          <section data-testid="impressum-dispute-block">
            <h2 className="font-serif text-2xl text-[#141414]">
              EU-Streitschlichtung
            </h2>
            <p className="mt-3">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit. Wir sind nicht bereit oder
              verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
